document.addEventListener('DOMContentLoaded', () => {
    const targets = document.querySelectorAll('.podcast-overview');

    for (const target of targets) {
        let offset = target.querySelectorAll('.podcast').length;
        const wrapper = target.querySelector('.podcast-overview__inner');
        const perPage = offset;
        const moreBtnParent = target.nextElementSibling;

        if (!moreBtnParent?.classList.contains('podcast-overview__more')) {
            continue;
        }

        const moreBtn = moreBtnParent.querySelector('button');
        const loader = moreBtnParent.querySelector('.loader');
        const text = moreBtnParent.querySelector('span');

        moreBtn.addEventListener('click', async () => {
            loader.classList.add('loader--loading');
            text.style.display = 'none';
            moreBtn.style.display = 'none';

            fetch(`${WP_DATA.ajax_url}?action=get_podcasts_action&offset=${offset}`, {
                method: 'GET',
            })
                .then(res => res.json())
                .then(({ data }) => {
                    const currPage = offset / perPage + 1;

                    if (currPage >= data.pages) {
                        moreBtnParent.style.display = 'none';
                    }

                    wrapper.innerHTML += data.elements.join('');

                    offset += perPage;

                    loader.classList.remove('loader--loading');
                    text.hidden = false;
                    moreBtn.hidden = false;
                }).catch(e => {
                    console.log("Error loading podcasts:", e)
                });
        });
    }
});
